import React from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import WorkspacesPanel from '@components/WorkspacesPanel';

const { Content, Sider } = Layout;

const workspacesListSiderWidth = 65;

function UxpPluginLayout() {
  return (
    <Layout id="app_layout" style={{ minHeight: '100vh', background: '#fff' }}>
      <Sider
        style={{
          height: '100vh',
          maxHeight: '100vh',
          position: 'fixed',
          left: 0
        }}
        className="workspaces_sider"
        width={workspacesListSiderWidth}
      >
        <WorkspacesPanel kind="uxp-plugin" />
      </Sider>
      <Layout
        className="site-layout"
        style={{
          background: '#fff',
          height: '100%',
          marginLeft: workspacesListSiderWidth,
          maxWidth: `calc(100% - ${workspacesListSiderWidth}px)`,
          overflowX: 'hidden'
        }}
      >
        <Content>
          <div className="site-layout-background" style={{ padding: '20px' }}>
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
}

export default UxpPluginLayout;
